export default {
    field: [
        {
            field: 'name',
            title: '文件名'
        },
        {
            field: 'desc',
            title: '描述'
        }
    ],
    plugin: [
        {
            name: 'etao_app.apk',
            desc: 'PDA软件安装包',
            url: '/static/print_plugin/etao_app.apk'
        },
        {
            name: 'Lodop-Clodop.zip',
            desc: 'LODOP打印控件.zip',
            url: '/static/print_plugin/Lodop-Clodop.zip'
        },
        {
            name: 'Lodop-Clodop官网',
            desc: 'LODOP打印控件官网',
            url: 'http://www.c-lodop.com'
        }
    ],
    document: [
    ]
}



// WEBPACK FOOTER //
// ./src/components/index/data/download.js